<template>
  <div id="service-modal" class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog" :style="{ width: width + 'px' }">
      <div class="modal-content">
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <div class="col-12 pl-0">
            <h3 class="modal-title">{{titleName}}</h3>
          </div>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommonServiceModal",
  props: {
    open: {
      type: Boolean,
      default: false
    },
    titleName: {
      type: String,
      default: ""
    }, 
    width: { 
      type: Number, 
      default: 900  // 寬度若外面沒傳入，預設900
    }
  }
};
</script>
